export default __webpack_public_path__ + "media/images/icons/check-circle-solid-08b1465f8b01df541f37beabf62c5b41.svg";